import { useLocalStore } from 'mobx-react-lite';

import Entities from 'STORE';
import { InputPanel } from 'STORE/InputPanelsStore/InputPanel/InputPanel';

interface IInputPanelPresenter {
  inputPanel: InputPanel | null;
  isShowRecordingVoice: boolean;
  isShowPreviewVoice: boolean;
  isShowInputPanel: boolean;
  hasBotCommands: boolean;
  canShowMentions: boolean;
  chanShowLinkPreview: boolean;
}

export function useInputPanelPresenter(): IInputPanelPresenter {
  const presenter = useLocalStore<IInputPanelPresenter>(() => ({
    get inputPanel(): InputPanel | null {
      return Entities.InputPanelsStore.activeInputPanel;
    },

    get canShowMentions(): boolean {
      return !presenter.inputPanel?.group?.isSecretGroup;
    },

    get chanShowLinkPreview(): boolean {
      return !presenter.inputPanel?.group?.isSecretGroup;
    },

    get isShowRecordingVoice(): boolean {
      return presenter.inputPanel?.voice?.isRecording || false;
    },

    get isShowPreviewVoice(): boolean {
      return presenter.inputPanel?.voice?.isPreviewMode || false;
    },

    get isShowInputPanel(): boolean {
      return !presenter.isShowRecordingVoice && !presenter.isShowPreviewVoice;
    },

    get hasBotCommands(): boolean {
      return presenter.inputPanel?.bots?.hasCommands || false;
    },
  }));

  return presenter;
}
